import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightShow20Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSidebarRightShow20Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M12.49 4.5H3.5a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h8.99zM1 5.5A2.5 2.5 0 0 1 3.5 3h13A2.5 2.5 0 0 1 19 5.5v9a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 1 14.5zm8.056 2.556a.75.75 0 0 0-1.06-1.06L5.52 9.47l-.53.53.53.53 2.475 2.476a.75.75 0 1 0 1.06-1.061L7.112 10z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightShow20Filled);
